import {useState, useEffect} from 'react';
import {getWithdrawAmountOptions} from '../services/withdraw-amount.service';

export interface WithdrawAmountOption {
  value: number;
  label?: string;
}

export interface UseWithdrawAmountOptionsReturn {
  options: (number | string)[];
  loading: boolean;
}

// 备用数据 - API 调用失败时使用
const fallbackAmountOptions = [
  200, 300, 500, 1000, 2000, 5000, 10000, 20000, 50000,
];

// Crypto 备用数据
const fallbackCryptoOptions: (number | string)[] = [300, 500, 1000, 'Max'];

const useWithdrawAmountOptions = (
  isCrypto?: boolean,
  enabled = true,
): UseWithdrawAmountOptionsReturn => {
  const [options, setOptions] = useState<(number | string)[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    if (!enabled) {
      setOptions([]);
      setLoading(false);
      return;
    }
    const fetchAmountOptions = async () => {
      setLoading(true);

      try {
        // useType: 1=UPI, 2=CRYPTO
        const useType = isCrypto ? 2 : 1;
        const response = await getWithdrawAmountOptions(useType);
        // 如果 API 返回空数组或空值，使用备用数据
        if (!response || !Array.isArray(response) || response.length === 0) {
          if (active) {
            setOptions(
              isCrypto ? fallbackCryptoOptions : fallbackAmountOptions,
            );
          }
        } else {
          // Crypto类型添加Max选项
          if (isCrypto) {
            if (active) {
              setOptions([...response, 'Max']);
            }
          } else {
            if (active) {
              setOptions(response);
            }
          }
        }
      } catch (error) {
        // API 调用失败时使用备用数据
        if (active) {
          setOptions(isCrypto ? fallbackCryptoOptions : fallbackAmountOptions);
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    fetchAmountOptions();
    return () => {
      active = false;
    };
  }, [isCrypto, enabled]);

  return {
    options,
    loading,
  };
};

export default useWithdrawAmountOptions;
